<template>
    <div class="main-content">
        <div class="main-header" :class="{active:main_header_active}">
            <span class="close-slide-btn d-i-b" @click="closeSlideLeft"><i class="el-icon-menu"></i></span>
            <span class="close-slide-btn d-i-b f-r" @click="styleChoose"><i class="icon ico-adjust"></i></span>
        </div>
        <transition name="view-option-transition">
            <keep-alive>
                <router-view/>
            </keep-alive>
        </transition>
        <div style="width:50px;height:50px;border-radius:50%;background:var(--slide-b-dark);box-shadow:0 2px 2px rgba(0,0,0,0.5);position:fixed;bottom:20px;right:20px;" @click="goTop"></div>
    </div>
</template>
<script>
    import $ from 'jquery'
    export default {
        data(){
            return {
                main_header_active:false,
            }
        },
        methods:{
            closeSlideLeft(){
                this.$parent.close_slide = !this.$parent.close_slide;
            },
            styleChoose(){
                this.$parent.leight = !this.$parent.leight;
            },
            routerLoading(){
                this.fullLoading();
                this.windowScroll();
            },
            fullLoading(){
                this.$parent.fullscreenLoading = true;
                setTimeout(() => {
                  this.$parent.fullscreenLoading = false;
                }, 2000);
            },
            windowScroll(){
                this.$nextTick(() => {
                    let that = this;
                    $('.el-scrollbar__wrap').scroll(() => {
                        var he=$('.window-scorll').offset().top;
                        if(he < 40){
                            that.main_header_active = true;
                        }else{
                            that.main_header_active = false;
                        }
                    });
                })
            },
            goTop(){
                this.$refs['scorll'].bodyWrapper.scrollTop = 40
                // $('.window-scorll').animate({scrollTop: '40px'}, 500);
                // console.log($('.window-scorll').offset().top)
            }
        },
        mounted(){
            
        }
    }
</script>
<style scoped lang="scss">
    .main-content{
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: #fff;
        padding-top: 40px;
        position: relative;
        .el-scrollbar {
            width: 100%;
            height: 100%;
            overflow-x: hidden;
        }
    }
    .main-header{
        width: 100%;
        height: 40px;
        position: absolute;
        top: 0;
        left: 0;
        transition: all 300ms;
        z-index: 10;
        &.active{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        }
    }
    .close-slide-btn{
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 24px;
        cursor: pointer;
        transition: background 200ms;
        &:hover{
            background: #f1f1f1;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/main-madel.vue